// @flow
/* eslint "jsx-a11y/click-events-have-key-events": "off", "jsx-a11y/no-static-element-interactions": "off" */

import React from 'react';

type Props = {
  iconBefore?: string,
  iconAfter?: string,
  text: string,
  type?: string,
  classes?: string,
  handleClick?: Function,
  handleDelete?: Function,
};

const BtnRounded = ({ iconBefore, iconAfter, text, type, classes, handleClick, handleDelete }: Props) => (
  <button
    type="button"
    className={`btn btn_rounded${type ? ` btn_${type}` : ''}${classes ? ` ${classes}` : ''}`}
    onClick={handleClick}
  >
    {iconBefore ? <i className={`icon-${iconBefore}`}/> : ''}
    {text}
    {iconAfter ? <i keyword={text} onClick={handleDelete} className={`icon-${iconAfter}`}> </i> : ''}
  </button>
);

BtnRounded.defaultProps = {
  iconBefore: '',
  iconAfter: '',
  classes: '',
  type: '',
  handleClick: () => {},
  handleDelete: () => {}
};

export default BtnRounded;
